import Axios from 'axios';
import { WAVVE_V2_API_BASE_URL } from '../config';
import { formatResponse } from '../main';

const BASE_PATH = 'downloads';

const axiosInstance = Axios.create({
  baseURL: WAVVE_V2_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `${localStorage.getItem('token')}`,
  },
});

axiosInstance.interceptors.response.use(formatResponse);

export default {
  async downloadJob({ name, guid, captions }) {
    const params = new URLSearchParams({
      name,
      guid,
      captions,
    });

    return await axiosInstance.get(`${BASE_PATH}/jobs`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
      },
    });
  },
};
